import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./index.css";
import { useEffect, useRef, useState } from "react";
import ChatMessage from "./ChatMessage";
import InitialMessage from "./InitialMessage";

const ChatHistory = ({
  chatHistory,
  appState,
  isApplicationPaused,
  applicationError,
  showTranscriptions,
  ExamAttemptId,
  textHidden,
  initialMessage
}) => {
  const [isChatHistoryExpanded, setIsChatHistoryExpanded] = useState(true);
  const contentWrapperRef = useRef(null);

  useEffect(() => {
    if (contentWrapperRef.current && chatHistory.length > 0) {
      contentWrapperRef.current.scrollTop =
        contentWrapperRef.current.scrollHeight;
    }
  }, [appState, chatHistory, applicationError]);

  return (
    <div className="speakingSectionChatHistoryContainer">
      <div className="speakingSectionChatHistoryHeaderContainer">
        <h3>Chat History</h3>
        <button
          onClick={() => setIsChatHistoryExpanded(!isChatHistoryExpanded)}
        >
          <FontAwesomeIcon
            icon={isChatHistoryExpanded ? faChevronDown : faChevronUp}
          />
        </button>
      </div>
      <div
        className="chatHistoryContentWrapper"
        ref={contentWrapperRef}
        style={{
          maxHeight: isChatHistoryExpanded ? "100%" : "0px",
          paddingBottom: applicationError
            ? "92px"
            : isChatHistoryExpanded
            ? "12px"
            : "0px",
          paddingTop: !isChatHistoryExpanded ? "0px" : "12px",
        }}
      >
        <InitialMessage message={initialMessage} />
        {chatHistory.map((chatEntry, index) => (
          <ChatMessage
            message={chatEntry.message}
            isUserMessage={chatEntry.isUserMessage}
            state={chatEntry.state}
            mp3FileUrl={chatEntry.mp3FileUrl}
            id={chatEntry.id}
            key={`chatEntry - ${chatEntry.id}`}
            audioControlsEnabled={
              appState === "waitingForUserAudio" ||
              isApplicationPaused ||
              (appState === "PlayingSystemResponse" &&
                index === chatHistory.length - 1)
            }
            showTranscriptions={showTranscriptions}
            ExamAttemptId={ExamAttemptId}
            textHidden={textHidden}
          />
        ))}
        {applicationError && (
          <div className="chatHistoryErrorContainer">
            <p>{applicationError.message}</p>
            <button onClick={applicationError.buttonAction}>
              {applicationError.buttonText}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatHistory;
